import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {dataMappingRoutes} from '@features/data-mapping/data-mapping.routes';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {DataMappingDynamicComponentHelper} from '@features/data-mapping/data-mapping-dynamic-component-helper';
import {PlatformToolDataMappingHandler} from '@features/data-mapping/services/platform-tool-data-mapping.handler';
import {CreateDataMappingCommandHandler} from '@features/data-mapping/services/create-data-mapping-command.handler';
import {EditDataMappingComponent} from './components/edit-data-mapping/edit-data-mapping.component';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {DataMappingApiProvider} from '@features/data-mapping/data-mapping-api-provider';
import {
  SelectDataMappingSourceDialogComponent
} from './components/select-data-mapping-source-dialog/select-data-mapping-source-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '@shared/shared.module';
import {
  ApplyDataMappingDetailViewDialogComponent
} from './components/apply-data-mapping-detail-view-dialog/apply-data-mapping-detail-view-dialog.component';
import {ApplyDataMappingCommandHandler} from '@features/data-mapping/services/apply-data-mapping-command.handler';
import {SelectDataMappingDialogComponent} from './components/select-data-mapping-dialog/select-data-mapping-dialog.component';
import {CreateDataMappingDialogComponent} from './components/create-data-mapping-dialog/create-data-mapping-dialog.component';
import {
  DataMappingSourceOrDestinationSelectorComponent
} from './components/data-mapping-source-or-destination-selector/data-mapping-source-or-destination-selector.component';
import {
  PlatformToolDataMappingFolderViewComponent
} from './components/platform-tool-data-mapping-folder-view/platform-tool-data-mapping-folder-view.component';
import {Api} from '@shared/constants/common-field.constants';
import {PlatformToolValueMappingHandler} from './services/platform-tool-value-mapping.handler';
import {DataMappingAdvancedSettingsCommandHandler} from '@features/data-mapping/services/data-mapping-advanced-settings-command-handler';
import { PlatformToolTrialBalanceMappingHandler } from './services/platform-tool-trial-balance-mapping.handler';
import { ShowArchiveTbMappingsCommandHandler } from './services/ShowArchiveTbMappingsCommandHandler'; 
import { PlatformToolDataExtractorHandler } from './services/platform-tool-data-extractor.handler';
import { DataMappingDeactivateWarningService } from './services/data-mapping-deactivate-warning.service';
import { DataMappingCanDeactivateGuard } from './guards/data-mapping-can-deactivate.guard';


@NgModule({
  declarations: [
    EditDataMappingComponent,
    SelectDataMappingSourceDialogComponent,
    ApplyDataMappingDetailViewDialogComponent,
    SelectDataMappingDialogComponent,
    CreateDataMappingDialogComponent,
    DataMappingSourceOrDestinationSelectorComponent,
    PlatformToolDataMappingFolderViewComponent
  ],
  imports: [
    RouterModule.forChild(dataMappingRoutes),
    CommonModule,
    MatRadioModule,
    FormsModule,
    SharedModule
  ],
  exports: [
    ApplyDataMappingDetailViewDialogComponent,
    SelectDataMappingDialogComponent
  ],
  providers: [
    DataMappingDeactivateWarningService,
    DataMappingCanDeactivateGuard
  ]
})
export class DataMappingModule {
  constructor(private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private platformToolDataMappingHandler: PlatformToolDataMappingHandler,
              private createDataMappingCommandHandler: CreateDataMappingCommandHandler,
              private applyDataMappingCommandHandler: ApplyDataMappingCommandHandler,
              private dataMappingAdvancedSettingsCommandHandler: DataMappingAdvancedSettingsCommandHandler,
              private platformToolTrialBalanceMappingHandler: PlatformToolTrialBalanceMappingHandler,
              private ShowArchiveTbMappingsCommandHandler: ShowArchiveTbMappingsCommandHandler,
              private platformToolValueMappingHandler: PlatformToolValueMappingHandler,
              private platformToolDataExtractorHandler: PlatformToolDataExtractorHandler
            ) {
    DataMappingDynamicComponentHelper.init();
    DataMappingDynamicComponentHelper.register('PlatformToolDataMappingHandler', platformToolDataMappingHandler);
    DataMappingDynamicComponentHelper.register('CreateDataMappingCommandHandler', createDataMappingCommandHandler);
    DataMappingDynamicComponentHelper.register('ApplyDataMappingCommandHandler', applyDataMappingCommandHandler);
    DataMappingDynamicComponentHelper.register('DataMappingAdvancedSettingsCommandHandler', dataMappingAdvancedSettingsCommandHandler);
    DataMappingDynamicComponentHelper.register('PlatformToolValueMappingHandler', platformToolValueMappingHandler);
    DataMappingDynamicComponentHelper.register('PlatformToolTrialBalanceMappingHandler', platformToolTrialBalanceMappingHandler);
    DataMappingDynamicComponentHelper.register('PlatformToolDataExtractorHandler', platformToolDataExtractorHandler);
    DataMappingDynamicComponentHelper.register('ShowArchiveTbMappingsCommandHandler', ShowArchiveTbMappingsCommandHandler);

    platformApiProvider.registerAtTop(new DataMappingApiProvider());
    let command = new PlatformCommand('CreateFieldMappingPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/field-mapping', command);

    command = new PlatformCommand('CreateFieldMappingReportsViewPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/reports', command);

    command = new PlatformCommand('CreateEntityMappingPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/entity-mapping', command);

    command = new PlatformCommand('CreateStreamMappingPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/stream-mapping', command);

    command = new PlatformCommand('CreateEntityTypeMappingPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/entity-type-mapping', command);

    command = new PlatformCommand('CreateFieldValueMappingPlatformLinkCommand', Api.FileStoreApi);
    command.setValue('MappingModule', 'ValueMappingModule');
    this.commandService.registrPlatformLinkCommand('/data-mapping/value-mapping', command);

    command = new PlatformCommand('CreateFieldValueMappingPlatformLinkCommand', Api.FileStoreApi);
    command.setValue('MappingModule', 'GrowthAssumptionModule');
    this.commandService.registrPlatformLinkCommand('/data-mapping/growth-assumptions', command);

    command = new PlatformCommand('CreateDataMappingFolderViewPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping', command);

    command = new PlatformCommand('CreateTrialBalanceMappingFolderViewPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/trial-balance-mappings', command);

    command = new PlatformCommand('CreateDataExtractorFolderViewPlatformLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/data-mapping/data-extractors', command);
  }
}
